import { render, staticRenderFns } from "./main-introduction.vue?vue&type=template&id=1b48ff2d&scoped=true"
import script from "./main-introduction.vue?vue&type=script&lang=js"
export * from "./main-introduction.vue?vue&type=script&lang=js"
import style0 from "./main-introduction.vue?vue&type=style&index=0&id=1b48ff2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48ff2d",
  null
  
)

export default component.exports